import CommonStyles from "../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...CommonStyles,

  mainWrap: {
    // width: "385px",
  },
  organisationLogo:{
    maxWidth: "90px",
    margin: "0",
  },
  orgDetailsContainer:{
    display:"flex",
    marginTop:"5px",
    alignItems:"center",
  },
  orgCommonButtons:{
  margin:"0 5px",
  fontSize:"12px",
  textTransform:"none",
  fontWeight:"bold",
  },
  orgAccept:{
    background:"#C39901",
    color:"#fff",
    marginLeft: "auto",
    marginRight: "0",
    "& span":{
      color:"#fff !important",
    },
    "&:hover":{
      background:"#C36A01",
    }
  },
  orgReject:{
    background:"#762F3B",
    color:"#fff",
    marginRight:"0",
    "& span":{
      color:"#fff !important",
    },
    "&:hover":{
      background:"#7B2534",
    }
  },
  messagesTabContent: {
    height: "100vh",
    width: "100%",
    background: "#303030",
    borderRadius: "0px",
    "& .MuiCircularProgress-colorPrimary":{
      color: "green !important",
      position: "absolute!important",
      right: "0!important",
      left: "0!important",
      top: "50%!important",
      margin: "0 auto!important",
    },
  },
  circularProgressIcon: {
    color: "green",
    top: "50%",
    right: "0",
    position: "absolute",
    left: "0",
    right: "0",
    margin: "0 auto",
  },
  addMargintoLeft:{
    marginLeft:"10px"
  },
  searchForm: {
    background: "#474747",
    borderBottom: "none",
    minHeight: "45px",
    "& div:before": {
      borderBottom: "0px solid #00D056 !important",
    },
  },
  selectBox: {
    width: "-webkit-fill-available",
    width:"100%",
    padding: "2px 12px",
    borderRadius: "4px",
    background: "#3B3B3B",
    border: "none",
    color: "#C1BDBD",
     fontSize:"1em",
    margin: "9px 20px 6px 10px",
    "&:hover": {
      color: "#00D056",
      "& .MuiSelect-icon": {
        color: "#00D056",
      },
    },
    "& :focus": {
      background: "none",
      color: "#00D056",
    },
    "&:focus-within": {
      "& .MuiSelect-icon": {
        color: "#00D056",
      },
    },
  },
  button: {
    border: "none",
    background: "none",
    margin: "10px 0 0px 0",
    padding: "5px",
    minWidth: "30px",
    height: "30px",
    lineHeight: "19px",
    boxShadow: "none",
    position: "relative",
    left: "-5px",
    "&:hover": {
      border: "none",
      background: "none",
      color: "#29D211",
    },
    "& .MuiCircularProgress-colorPrimary":{
      top:"inherit !important"
    }
  },
  circularProgressIcon: {
    height: "12px !important",
    width: "12px !important",
    color: "#FFFFFF",
  },
  searchIcon: {
    fontSize: "20px",
  },
  searchTextField: {
    background: "#505050",
    borderRadius: "4px",
    padding: "0px 15px",
    margin: "10px 15px 10px 0px",
    width: "calc(100% - 75px)",
     fontSize:"1em",
    "& .MuiInput-underline:hover:not($disabled):before": {
      borderBottom: "1px solid #00D056 !important",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #00D056",
    },
    "& input": {
       fontSize:"0.75em",
    },
  },
  messages: {
    height: "calc(100% - 97px)",
    overflowX: "auto",
    width: "100%",
    background: "#303030",
    borderRadius: "0px",
    borderBottom: "none",
    boxShadow: "none",
   
  },
  noMessage: {
    textAlign: "center",
    padding: "20px",
     fontSize:"0.75em",
  },

  messageUnseen: {
    display: "block",
    background: "#667690",
    borderRadius: "4px",
    cursor: "default",
    padding: "10px",
    fontWeight: "bold",
    borderBottom:"1px solid #1e232e",
    margin: "8px",
    "&:hover":{
      backgroundColor:"#43546f",
    },
    "&:hover date": {
      display: "none",
    },
    "&:focus-within": {
      "& date": {
        display: "none",
      },
    },
    "& div":{
      color:"#fff",
      fontWeight: "bold",
    },
    "&.Mui-focusVisible date": {
      display: "none",
    },
    "& button": {
      visibility: "hidden",
    },
    "&:focus-within": {
      "& button": {
        visibility: "visible",
      },
    },
    "&:hover button": {
      visibility: "visible",
    },
  },
  newMessageRecieved:{
    position:"absolute",
    zIndex: "9",
    background: "#da5555",
    fontSize: "12px !important",
    borderRadius: "50%",
    width: "15px",
    height: "15px",
    color: "#fff !important",
    textAlign: "center",
    padding: "3px",
    left: "27px",
    bottom: "-3px",
    "& svg":{
      fontSize:"12px"
    }
  },
  message: {
    display: "block",
    background: "#1f1f1f",
    borderRadius: "4px",
    cursor: "default",
    padding: "10px",
    margin: "8px",
    border:"1px solid #4f4f4f",
    color:"#9d9d9d",   
    "&:hover":{
      backgroundColor:"#2d2d2d",
      opacity:"1",
    },
    "&:hover date": {
      display: "none",
    },
    "&:focus-within": {
      "& date": {
        display: "none",
      },
    },
    "&.Mui-focusVisible date": {
      display: "none",
    },
    "& button": {
      visibility: "hidden",
    },
    "&:focus-within": {
      "& button": {
        visibility: "visible",
      },
    },
    "&:hover button": {
      visibility: "visible",
    },
  },
  circularProgressIconAsFeedback: {
    color: "#00D056",
    margin: "100px calc(50% - 20px)",
  },
  messageOuterContainer: {
    display: "flex",
    minHeight: "42px",
    alignItems: "center",
    cursor: "pointer",
    "& span":{
      fontSize:"11px",
      marginLeft:"0",
    },
  },
  spanmargin:{
    "&  span":{
      marginRight:"5px",
    }
  },  
  messageContentWrap:{
    width:"100%",
    overflow:"hidden",
  },
  messageSenderContainer: {
    borderRadius: "20px",
    marginRight: "5px",
  },
  usersIconContainer: {
    position:"relative",
    "& .MuiAvatar-circle": {
      margin: "3px",
      background: "#cacaca",
      borderRadius: "50% !important",
    },
  },
  smallAvatar: {
    margin: "7px",
    width: "34px",
    height: "34px",
  },
  messageContentContainer: {
    width: "calc(100% - 175px)",
    margin: "0px 10px",
    display: "flex",
    alignItems: "center",
  },
  messageTitleInnerContainer: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    color: "#a2a2a2",
  },
  messagesWraps: {
    height: "calc(100% - 160px)",
    overflow: "auto",
    "& hr":{
      borderColor:"#707476",
    },
  },
  messagebodyRead:{
    fontSize: "17px !important",
    marginRight: "5px",
    color: "#00adff",
    display:"none",
  },
  composeTextArea:{
    position:"relative",
  },
  messagebodyattachement:{
    // display: "flex",
    "& > div":{
      background: "#1f1f1f",
      borderRadius: "3px",
      padding: "5px 10px",
      margin: "2px",
      display: "inline-block",
      border:"1px solid #4b4a4a",
      verticalAlign:"top",
      "&:focus":{
        border:"1px solid #14bb00",
        outline:"none",
      },  
      "&:hover":{
        border:"1px solid #14bb00",

      },     
    },   
    float: "left",
    marginLeft: "61px",
    fontSize: "12px",
    width: "77%",
    whiteSpace: "break-spaces",
    "& span":{
    //   display: "flex",
    // alignItems: "baseline",
    
    },
    "& span span":{
     marginLeft:"2px",
    },
    "& a":{
      color:"#14bb00",
      display: "flex",
      outline:"none",
     }  
  },
  messagebodyattachementIcon:{
    fontSize: "17px",
    marginRight: "5px",
    lineHeight:"1",
    verticalAlign:"top",
  },
  messagebodyInnerContainer: {
    fontSize: "1.1em",
    color: "#fff",
    paddingRight: "20px",
    display: "flex",
    "& div":{
      // whiteSpace:" break-spaces",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }
  },
  messagebodyDate:{
    textAlign: "right",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginLeft: "5px",
    width: "100%",
  },
  messageAttachmentInnerContainer: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "flex",
  },
  draftLabel: {
    border: "1px solid rgba(81, 81, 81, 1)",
    borderRadius: "18px",
    padding: "0px 7px",
    marginRight: "5px",
    background: "#BB5858",
    display: "flex",
  },
  draftText: {
    fontSize: "8pt",
    padding: "2px",
    color: "white",
  },
  newLabel: {
    border: "1px solid #18944c",
    borderRadius: "18px",
    padding: "0px 7px",
    marginRight: "5px",
    background: "#18944c",
    display: "inline-block",
  },
  newText: {
    fontSize: "8pt",
    padding: "2px",
    color: "white",
  },
  messageTimestampInnerContainer: {
    color: "#AEAEAE",
    fontSize: "11px",
  },
  messageButtonsInnerContainer: {
    position: "absolute",
    top: "12px",
    width: "130px",
    textAlign: "right",
    right: "14px",
    "& button svg": {
      fontSize: "20px",
    },
    "& button": {
      padding: "8px",
    },
  },
  composeNewMessage: {
    "& textarea": {
      background: "#2c475f",
      boxSizing: "border-box",
      maxWidth:"100%",
      borderRadius: "10px",
      maxHeight:"220px",
      width: "-webkit-fill-available",
      width:"100%",
      color: "#fff",
      padding: "10px",
      border: "1px solid #436e94",
      resize:"none",
      fontFamily:
        "'Roboto', 'Helvetica', 'Arial',  sans-serif , 'Segoe UI', 'Roboto', 'Oxygen'",
      fontSize: "12px",
    },
    "& .MuiAutocomplete-hasClearIcon": {
      width: "100%",
      margin: "5px 0 10px 0",
      border: "none",
      "& input": {
        padding: "10px!important",
        fontSize: "12px",
      },
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:not($disabled):before": {
      borderBottom: "1px solid #00D056 !important",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #00D056",
    },
    "& input": {
      padding: "10px!important",
      fontSize: "12px",
    },
  },
  newMsgwrp: {
    padding: "10px 15px 0px 15px",
    // background: "#252525",
    borderRadius: "0px",
    "& .MuiFormControl-fullWidth": {
      border: "1px solid #5a5959",
      borderRadius: "3px",
      background: "#474747",
    },
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      margin: "3px",
      maxWidth: "calc(100% - 6px)",
    },
    "& textarea:focus": {
      border: "1px solid green",
      outline: "none",
    },
    "& textarea:hover": {
      border: "1px solid green",
      outline: "none",
    },
    "& textarea:active": {
      border: "1px solid green",
      outline: "none",
    },
  },
  composeNewMessageWrapper: {
    padding: "5px 8px 5px 5px",
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      margin: "3px",
      maxWidth: "calc(100% - 6px)",
    },
    "& .MuiAutocomplete-hasClearIcon": {
      margin: "10px 0",
      background: "#474747",
      borderRadius: "3px",
      border: "1px solid #707070",
      boxSizing:"border-box"
    },
    "& .MuiAvatar-circle":{
      margin:"3px 8px 3px 3px",
      width:"24px",
      height:"24px",
    }
  },
  composeDate:{
    marginLeft:"5px",
    fontSize: "11px",
  },
  composeRecipient: {
    background: "#4B5E6B",
    color: "#fff",
    fontSize: "1em",
    margin: "15px",
    padding: "15px",
    borderRadius: "10px",
    lineHeight: "19px",
    // maxHeight: "240px",
    overflow: "auto",
    textAlign:"left",
    "& .MuiAvatar-square": {
      width: "42px",
      height: "42px",
      marginRight: "10px",
      borderRadius: "3px",
      border: "1px solid #999",
    },
  },
  composeCreateNew: {
    // background: "#474747",
    color: "#fff",
    position:"relative",
    margin: " 0",
    padding: "10px 15px 15px 15px",
    marginBottom: "10px",
    borderRadius: "3px",
    "& textarea": {
      border: "none",
      outline: "none",
      height: "160px !important",
    },
    "& textarea:focus": {
      border: "none",
      outline: "none",
    },
    "& button":{
      marginRight:"0",
      marginTop:"10px",
      marginLeft:"0",
    },
    "& .MuiAvatar-square": {
      width: "42px",
      height: "42px",
      marginRight: "10px",
      borderRadius: "3px",
      border: "1px solid #999",
    },
    "& > div": {
      background: "#303030",
      position:"relative",
    },
    "& .MuiCircularProgress-colorPrimary":{
      color: "inherit !important",
      position: "inherit !important",
      right: "inherit!important",
      left: "inherit!important",
      top: "inherit!important",
      margin: "0 0 0 8px !important"
    },
  },

  composeSender: {
    background: "#191919",
    color: "#fff",
    fontSize: "12px",
    margin: "10px 10px 10px auto",
    padding: "15px",
    borderRadius: "3px",
    width: "60%",
  },

  composeSenderLeft: {
    background: "#206696",
    color: "#aedeff",
    fontSize: "12px",
    margin: "10px 15px 10px auto",
    padding: "15px",
    borderRadius: "10px",
    width: "70%",
    textAlign:"right",
    maxWidth:"450px",
    "& div":{
      wordBreak:"break-word",
      justifyContent: "flex-end",
      color:"#fff !important",
      fontSize:"1.1em",
    },
    "& span":{
    color: "#d6eeff",
    fontSize: "11px",
    marginLeft: "5px",
    display: "block",
    marginTop:"5px",
}
  },

  composeSenderRight: {
    color: "#adddff",
    fontSize: "12px",
    margin: "auto 10px 10px 10px",
    padding: "15px",
    borderRadius: "10px",
    width: "70%",
    border:"1px solid #1e9494",
    background: "#135858",
    marginBottom: "10px",
    marginLeft: "15px",
    textAlign:"left",
    maxWidth:"450px",
    "& time":{
      marginTop: "5px",
      display: "block",
    },
    "& div":{
      justifyContent: "flex-start",
    },
    "& div":{
      wordBreak:"break-word",
      color:"#fff",
      fontSize:"1.1em",
    },
    "& span":{
      color: "#39e0e0",
      fontSize: "11px",
      wordBreak:"break-word",
      display: "block",
      
  },
  "& a:focus":{
    outline:"none",
    background:"#484848",
},
"& a:hover > span":{
   textDecoration:"underline",
}

  },
  messagebodyUserDetails:{
    // display: "flex",
    // alignItems: "baseline",
    fontSize:"1em",
    color: "#9d9d9d",
    margin:"0",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  messagebodyCreatedUserDetails:{
    fontSize:"12px",
    color: "#ffffff",
    margin:"0",
    fontWeight: "500",
    "& span":{
      fontSize: "11px",
      display:"block",
  }
  },
  msgBodyInner:{
    margin:"0px 0 5px 0",
  },
  replyAttachment:{
    fontSize:"12px",
    "& .MuiAvatar-square":{
      width: "30px",
      height: "30px",
      marginRight:"10px",
    },
  },  
  composeAttachment: {
    background: "#171717 !important",
    borderRadius: "3px",
    marginBottom: "10px", 
    "& > div": {
      display: "flex",
      alignItems: "center",
    },
    "& a": {
      display: "flex",
      color: "#fff",
      textAlign:"left",
      padding:"10px",
      width:"-webkit-fill-available",
      width:"100%",
      borderRadius:"3px",
    },
    "& a:focus":{
      outline:"none",
      // background:"#595959",
  },
  "& a:focus span":{
    color:"#fff !important",
    textDecoration:"underline",
},
    "& .MuiAvatar-square":{
      marginRight:"10px",
    },
    "& a:hover":{
      textDecoration:"underline",
    },
  },
  composeTrackName:{
    width:"-webkit-fill-available",
    width:"100%",
    textAlign: "left",
    lineHeight: "15px",
    display: "block",
    fontSize: "0.8em",
    wordBreak: "break-word",
  },
  composeRemoveItem:{
    // width: "-webkit-fill-available",
    fontSize: "12px",
    width: "30px",
    height: "30px",
    marginRight:"10px !important",
    marginTop:"0px !important",
    "& svg":{
      fontSize:"1.3em",
      cursor:"pointer",
      "&:hover":{
        opacity:"0.8",
      }
    }
  },
  customIcon: {
    fontSize: "16px",
    marginRight: "10px",
  },
  composeArtist: {
    display: "block",
    color: "#ababab !important",
    fontSize: "11px",
  },
  minHeightWrapper:{
    maxHeight:"150px",
    overflow: "auto",
  },
  composeCreateNewMessage: {
    position: "absolute",
    bottom: "0",
    padding: "10px",
    width:"calc(100% - 20px)",
    background: "#303030",
   
    "& button": {
      margin: "10px 0px 0px 0px",
    },
    "& .MuiIconButton-root":{
      margin:"0 5px 0px 0px",
    },
    "& .MuiInput-underline .MuiButton-root":{
      margin:"0 10px 0px 5px",
    },
    
  },
  searchFormHeader: {
    background: "#242424",
    display: "flex",
  },
  MessageKeywordWrapper: {
    padding: "0 10px",
    background: "#404040",
    borderBottom: "1px solid #545454",
  },
  panelHeader: { 
    display: "flex",
    padding: "0 10px",
    background: "#242424",
    alignItems: "center",
    "& button":{
      verticalAlign: "middle",
    padding: "4px 8px",
    margin: "10px 0 13px 10px",
    fontSize: "18px",
    background: "none",
    border: "1px solid #535353",
    borderRadius: "5px",
    color: "#fff",  
    },
    "& button:hover":{
      background:"#000",
      cursor:"pointer",
    },
    "& h2":{
      width: "-webkit-fill-available",
      width:"100%",
       fontSize:"0.9em",
      fontWeight: "500",
      whiteSpace: "nowrap",
      overflow: "hidden",
      maxWidth: "330px",
      textOverflow: "ellipsis",
      "& svg":{
        fontSize: "28px",
        verticalAlign: "middle",
        marginRight: "10px",
      }
    },
},
commonBackButton:{
margin:"10px 10px 10px 0px !important",
padding: "8px 6px !important",
minWidth:"36px",
},

  recipientName: {
    width: "60px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "11px",
    height: "inherit",
    marginTop: "0",
    lineHeight: "11px",
    whiteSpace: "nowrap",
  },

  recipientEmail: {
    width: "75px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "11px",
    color: "#8A8A8A",
    height: "15px",
  },
  cancelButtonRoot: {
    minWidth: "0px",
    padding: "0px",
    margin: "0px 8px 0px 8px",
    borderRadius: "10px",
  },
  closeIconRoot: {
    fontSize: "11px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    padding: "15px 0 5px 0",
  },
  headerSubject: {
    margin: "0px",
    minWidth: "calc(100% - 126px)",
    width: "calc(100% - 126px)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "11px",
  },
  headerDate: {
    color: "#B5B5B5",
    fontSize: "12px",
  },
  recipientLabel: {
    border: "1px solid rgba(81, 81, 81, 1)",
    borderRadius: "5px",
    padding: "0px",
    margin: "5px ",
    background: "#212121",
    display: "flex",
    alignItems: "center",
    textAlign:"left",
    "& .MuiAvatar-circle":{
      margin:"3px 8px 3px 3px",
      width:"24px",
      height:"24px",
    },
    "& div":{
      lineHeight:"1"
    }
  },
  commonTopButton: {
    padding: "9px",
    height: "32px",
    width: "32px",
    minWidth: "inherit",
    marginTop: "7px",
    marginLeft: "0px",
  },
  buttonCustomSize: {
    "& svg": {
      fontSize: "16px !important",
    },
  },
  buttonGreenButton:{
    background: "#0C853E !important",
    border: "1px solid #0C853E !important",
    marginRight:"0 !important",
    "& svg":{
      fontSize: "17px",
    },
    "&:hover":{
      background: "#000 !important",
      color: "#0C853E !important",
    }
  },
  composeAbsoluteContainer:{
    overflow: "auto",
    height: "calc(100% - 370px)",
    position: "absolute",
    width: "99.2%",
  },
  textAreaMinHeight:{
    minHeight:"160px",
    background:"#000",
    "&:focus":{
      outline:"none",
      border:"1px solid green",
    }
  },
  newModuleClass:{
    marginTop:"10px",
    overflow:"hidden",
    textAlign:"left",
    "& .MuiSelect-select":{
      paddingTop:"10px",
      paddingBottom:"10px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline":{
      borderColor: "#46af22",
    }
  },
  messagePagination:{
    "& .MuiTablePagination-input":{
      marginRight:"12px",
      marginLeft: "0px",
    },
    "& .MuiTablePagination-actions":{
      marginLeft: "10px",
    },
    "& .MuiToolbar-gutters":{
      paddingLeft: "10px",
    },
    "& .MuiSelect-select":{
      background:"#5d5d5d",
      borderRadius: "3px",
    },
    "& .Mui-focused .MuiSelect-select":{
      background:"#807f7f",
    }
  },
  contentRequestStatus:{
    fontSize: "0.8em",
    color:"#fff !important",
    fontWeight:"normal !important",
    display: "block",
    padding: "2px 8px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "right",
    float: "right",
    boxSizing: "border-box",
    minWidth: "auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width:"auto",
    textOverflow: "ellipsis",
    textAlign:"center"
  },
  
  contentRequested:{
    background:"#0c853e",
    fontSize: "0.8em",
    color:"#fff !important",
    fontWeight:"normal !important",
    display: "block",
    padding: "2px 8px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "right",
    float: "right",
    boxSizing: "border-box",
    minWidth: "auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width:"auto",
    textOverflow: "ellipsis",
    textAlign:"center"

  },
  contentNotsourced:{
    background:"#953c3c",
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "0.8em",
    display: "block",
    padding: "2px 8px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    float: "right",
    boxSizing: "border-box",
    minWidth: "90px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width:"auto",
    textAlign:"center !important"
  },
  contentAcknowledged:{
    background:"#705200",
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "0.8em",
    display: "block",
    padding: "2px 8px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    float: "right",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width:"auto",
    textAlign:"center"
  },
  contentSuccessful:{
    background:"#015C6A", 
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "0.8em",
    display: "block",
    padding: "2px 8px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    float: "right",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width:"auto",
    textAlign:"center"
  },
  contentRejected:{
    background:"#A22F2F", 
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "0.8em",
    display: "block",
    padding: "2px 8px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "right",
    float: "right",
    boxSizing: "border-box",

    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width:"auto",
    textAlign:"center"
  },
  messageContentMessage:{
   "& .innerStatus":{
     float:"left",
     fontSize: "11px",
   }
},
messageContentMessages:{
  width:"-webkit-fill-available",
  width:"100%",
  fontSize: "0.8em",
  wordBreak: "break-word",
  "& > div":{
    marginRight:"10px",
  }
},
replyMessageButtonSet:{
  display:"flex",
  alignItems: "baseline",
  "& > div":{
    width:"100%",
    margin: "0 10px 0 0px",
  },
  "& .MuiSelect-select":{
    padding: "6px 32px 8px 10px",
    textAlign: "left",
    "&:hover":{
      borderColor:"#46af22",
    },   
  },
  "&:hover .MuiOutlinedInput-notchedOutline":{
    borderColor:"#46af22",
  },
  "& .MuiCircularProgress-colorPrimary":{
    color: "inherit !important",
    position: "inherit !important",
    right: "inherit!important",
    left: "inherit!important",
    top: "inherit!important",
    margin: "0 0 0 8px !important"
 
  },
},
tableFilterInput: {
  width:"100%",
  "& input": {
    borderRadius: "5px !important",
    padding: "8.5px 27px 8.5px 8.5px",
     fontSize:"0.8em",
    background:" #4A4949",
  },
  "& div": {
    borderRadius: "5px !important",
    width:"100%"
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  }
},
sentNotification:{
  background: "#262626",
    borderRadius: "3px",
    fontSize: "0.75em",
    padding: "10px",
    textAlign: "left",
    border:"1px solid #5a5a5a",
    "& svg":{
      color:"green",
      fontSize:"24px",
      marginRight:"10px",
      verticalAlign:"middle",
    }
},
msgDrawer:{
  background:"red"
},
 popupwindow:{
   maxWidth:"85%",
   margin:"0 auto",
   "& > div[aria-hidden='true']":{
    backgroundColor:"rgba(0, 0, 0, 0.9) !important",
  }
 },

//  New UI
messagebodyNewDate:{
  textAlign: "left",
  overflow: "hidden",
  textOverflow: "ellipsis",
  margin: "5px 5px 5px 0",
  float:"left",
  width: "auto",
  "& .smallDevices ":{
    float:"left"
  }
},
messagebodyMainDate:{
  textAlign: "left",
  overflow: "hidden",
  textOverflow: "ellipsis",
  marginLeft: "0",
  width: "100%",
  display:"flex",
  alignItems:" center",
},
messageMainBoxContainer: {
  minHeight: "42px",
  alignItems: "center",
  cursor: "pointer",
  overflow:"hidden",
  width:"100%",
  "& span":{
    fontSize:"11px",
    marginLeft:"0",
    color:"rgba(255,255,255, 0.6)",
    marginLeft:"0",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
},
usersContainer:{
    position:"relative",
    display:"flex",
    alignItems: "center",
    margin: "0 0 3px 0",
    "& .MuiAvatar-circle": {
      margin: "3px 0 ",
      background: "#cacaca",
      borderRadius: "50% !important",
    },
  },
  smallUserAvatar: {
    margin: "7px",
    width: "24px",
    height: "24px",
    marginRight:"10px !important",
  },
bodyUserDetails:{
  fontSize:"1em",
  margin:"0",
  overflow: "hidden",
  textOverflow: "ellipsis",
},
 sentItem :{
  borderRadius: "10px",
  "& .userNames":{
    color:"#cecece",
    fontSize:"0.85em"
  },
  "& .reverseOrder":{
    flexDirection: "row-reverse",
  },
  "& .MuiAvatar-circle":{
    marginRight:"0px !important",
    marginLeft:"10px !important",
  }
  },
  receivedItem:{ 
    "& .userNames":{
      color:"#d6eeff",
      fontSize:"0.9em"
    },

  },
  unreadMessage:{
    background:"#206697",
    border:"1px solid #2495e3",
    margin: "10px 10px 5px 10px",
    borderRadius: "10px",
    padding:"10px",
    "& hr":{
      borderColor:"#3789c1",
    },
    "&:hover":{
      backgroundColor:"#072752", 
    },
  },
  messageBox: {
    display: "block",
    background: "#474747",
    cursor: "default",
    padding: "10px",
    margin: "10px 10px 5px 10px",
    border:"1px solid #4f4f4f",
    color:"#9d9d9d",   
    borderRadius:"10px",
    "& .userNames":{
      color:"#cecece"
    },
    "& .smallDevices":{
      color:"#fff",
    },
    "&:hover":{
      backgroundColor:"#2d2d2d",
      opacity:"1",
    },
    "&:hover date": {
      display: "none",
    },
    "&:focus-within": {
      "& date": {
        display: "none",
      },
    },
    "&.Mui-focusVisible date": {
      display: "none",
    },
    "& button": {
      visibility: "hidden",
    },
    "&:focus-within": {
      "& button": {
        visibility: "visible",
      },
    },
    "&:hover button": {
      visibility: "visible",
    },
  },
  messagebodyattachementNew:{
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& > div":{
      background: "#1f1f1f",
      borderRadius: "3px",
      padding: "5px 10px",
      margin: "2px",
      display: "inline-block",
      border:"1px solid #4b4a4a",
      verticalAlign:"top",
      "&:focus":{
        border:"1px solid #14bb00",
        outline:"none",
      },  
      "&:hover":{
        border:"1px solid #14bb00",

      },     
    },   
    float: "left",
    marginLeft: "0",
    fontSize: ".85em",
    fontWeight:"bold",
    marginRight: "5px",
    "& span":{
    //   display: "flex",
    // alignItems: "baseline",
    
    },
    "& span span":{
     marginLeft:"2px",
    },
    "& a":{
      color:"#14bb00",
      display: "flex",
      outline:"none",
     }  
  },
  messagebodyInnerContainerNew: {
    fontSize: "1.1em",
    color: "#fff",
    paddingRight: "20px",
    display: "flex",
    fontWeight: "500",
    "& a":{
      color:"#26b70b",
    },
    "& div":{
      // whiteSpace:" break-spaces",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }
  },
});
